module.exports = __webpack_public_path__ + "static/media/griffith.a35ecd59.png";